import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { get, omit } from 'lodash-es';
import { getQuery } from 'client/utils/location';
import { objectToQueryString } from 'site-modules/shared/utils/string';

export function EditLinkUI({ location, name }) {
  const { pathname } = location;
  const currentQuery = getQuery(location);

  return (
    <a
      href={`${pathname}?${objectToQueryString(omit(currentQuery, 'priceBreakdown'))}`}
      className="edit-link ms-1 fw-normal medium"
    >
      Edit
      <span className="visually-hidden">&nbsp;{name}</span>
    </a>
  );
}

EditLinkUI.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string,
    search: PropTypes.string,
  }).isRequired,
  name: PropTypes.string.isRequired,
};

export const mapStateToProps = state => ({
  location: get(state, 'pageContext.location'),
});

export const EditLink = connect(mapStateToProps)(EditLinkUI);
